export type DemoAccount = {
    name: string;
    email: string;
    role: string;
    mobile?: string;
    office?: string;
};

export const defaultDemoAccount: DemoAccount = {
    name: '사용자',
    email: '',
    role: '',
    mobile: '',
    office: ''
};

export function getDemoAccount(context: any = null): DemoAccount {
    const user = context?.user || {};
    const platformRoles = Array.isArray(context?.platform_roles)
        ? context.platform_roles
        : [];
    const coreRole = [
        'PLATFORM_SUPER_ADMIN',
        'IP_MANAGEMENT_ADMIN',
        'IP_MARKET_ADMIN'
    ].find((role) => platformRoles.indexOf(role) >= 0) || '';
    const legacyRole = context?.legacy_role || user.role || '';
    const displayRole = coreRole || (legacyRole === 'admin' ? 'admin' : '');
    const activeTenant = context?.active_tenant;
    const activeMembership = Array.isArray(context?.memberships)
        ? context.memberships.find(
            (membership: any) => membership.id === activeTenant?.membership_id
        )
        : null;
    const tenant = activeMembership?.tenant || activeTenant?.tenant || activeTenant;

    return {
        name: user.display_name || user.name || defaultDemoAccount.name,
        email: user.email || defaultDemoAccount.email,
        role: displayRole,
        mobile: user.phone || '',
        office: tenant?.name || tenant?.display_name || ''
    };
}

// Compatibility exports intentionally never persist identity or authority in browser storage.
export function saveDemoAccount(_account: Partial<DemoAccount>): DemoAccount {
    return { ...defaultDemoAccount };
}

export function clearDemoAccount() {
    return;
}

export function accountInitial(account: DemoAccount = getDemoAccount()) {
    return (
        account.name?.trim().charAt(0)
        || account.email?.trim().charAt(0).toUpperCase()
        || 'W'
    );
}

export function roleLabel(role: string) {
    const labels: any = {
        PLATFORM_SUPER_ADMIN: '최고 관리자',
        IP_MANAGEMENT_ADMIN: 'IP 관리 관리자',
        IP_MARKET_ADMIN: 'IP 거래 관리자',
        admin: '관리자'
    };
    return labels[role] || '권한 없음';
}
